(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TransportationDeleteController',TransportationDeleteController);

    TransportationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Transportation'];

    function TransportationDeleteController($uibModalInstance, entity, Transportation) {
        var vm = this;
        vm.transportation = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Transportation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
